'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return {
    require: 'ngModel',
    link: function link(scope, elem, attrs, ctrl) {
      var firstPassword = '#' + attrs.pwMatch;

      // fa riferimento al campo conferma password
      elem.bind('blur', function (evt) {
        scope.$apply(function () {
          var v = elem.val() === $(firstPassword).val();
          ctrl.$setValidity('pwmatch', v);
        });
      });

      // fa riferimento al campo conferma password
      elem.bind('keyup', function (evt) {
        scope.$apply(function () {
          var v = elem.val() === $(firstPassword).val();
          if (v === true) {
            ctrl.$setValidity('pwmatch', v);
          }
        });
      });

      // fa riferimento al campo nuova password
      $(firstPassword).bind('blur', function (evt) {
        scope.$apply(function () {
          var v = elem.val() === $(firstPassword).val();
          if (ctrl.$dirty) {
            ctrl.$setValidity('pwmatch', v);
          }
        });
      });
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/infocert-utils/distribution/utils.ui/pwMatchValidation.js
// module id = 149
// module chunks = 2